import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveRecipeNotificationInput } from './SaveRecipeNotificationInput';
import { SaveRecipeNotificationOutput } from './SaveRecipeNotificationOutput';

export class SaveRecipeNotificationService extends HttpServiceBase {

  handle = (input: SaveRecipeNotificationInput): Promise<Result<SaveRecipeNotificationOutput> | null> => {
    const promise = this.http.post<Result<SaveRecipeNotificationOutput>, SaveRecipeNotificationInput>(`${this.baseUrlSislogApi}/v2/recipe/notification`, input);
    return promise;
  }
}